// extracted by mini-css-extract-plugin
export default {"container":"DP8UKkEp21m4GpXZzGUB"};